import React from "react";

const ErrorBox = ({ msg }) => {
  return <ul className="box-error">{msg && msg.map(m => <li className="msg text-danger">{m}</li>)}</ul>;
};

export default ErrorBox;
